<template>
  <editable-base
    ref="base"
    :mode="mode"
    :label="label"
    :error-message="errorMessage"
    :readonly="readonly"
    :show-buttons="showButtons"
    :showErrorMessage="showErrorMessage"
  >
    <b-form-input
      v-if="editValue || mode === modes.edit"
      @click="handleMaybeEditClick"
      :class="[
        'est-input',
        mode === modes.processing ? 'text-secondary' : '',
        readonly ? 'readonly' : ''
      ]"
      :id="id"
      v-model="editValue"
      :plaintext="mode !== modes.edit"
      :readonly="readonly"
    /><template v-else>
      <p @click="handleMaybeEditClick" class="text-muted small font-italic">
        no value set {{ readonly ? "" : "&mdash; click to add" }}
      </p>
    </template>
  </editable-base>
</template>

<script>
import { BFormInput } from "bootstrap-vue";
import EditableBase, { Mixin } from "./EditableBase";

// todo on save, disable field, emit event, wait for response -- may fail validation

export default {
  name: "EditableText",
  mixins: [Mixin],
  components: {
    BFormInput,
    EditableBase
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
